export const optionsStates = [
  { id: 'AC', title: 'AC - Acre' },
  { id: 'AL', title: 'AL - Alagoas' },
  { id: 'AP', title: 'AP - Amapa' },
  { id: 'AM', title: 'AM - Amazonas' },
  { id: 'BA', title: 'BA - Bahia' },
  { id: 'CE', title: 'CE - Ceara' },
  { id: 'DF', title: 'DF - Distrito Federal' },
  { id: 'ES', title: 'ES - Espirito Santo' },
  { id: 'GO', title: 'GO - Goias' },
  { id: 'MA', title: 'MA - Maranhão' },
  { id: 'MT', title: 'MT - Mato Grosso' },
  { id: 'MS', title: 'MS - Mato Grosso do Sul' },
  { id: 'MG', title: 'MG - Minas Gerias' },
  { id: 'PA', title: 'PA - Pará' },
  { id: 'PB', title: 'PB - Paraíba' },
  { id: 'PR', title: 'PR - Paraná' },
  { id: 'PE', title: 'PE - Pernambuco' },
  { id: 'PI', title: 'PI - Piauí' },
  { id: 'RJ', title: 'RJ - Rio de Janeiro' },
  { id: 'RN', title: 'RN - Rio Grande do Norte' },
  { id: 'RS', title: 'RS - Rio Grande do Sul' },
  { id: 'RO', title: 'RO - Rondônia' },
  { id: 'RR', title: 'RR - Roraima' },
  { id: 'SC', title: 'SC - Santa Catarina' },
  { id: 'SP', title: 'SP - São Paulo' },
  { id: 'SE', title: 'SE - Sergipe' },
  { id: 'TO', title: 'TO - Tocântins' },
];

export const optionsOrgaoEmissorRg = [
  { id: 'SSP', title: 'SSP - Secretaria de Segurança Pública' },
  { id: 'PC', title: 'PC - Polícia Civil' },
  { id: 'SESP', title: 'SESP - Secretaria de Estado de Segurança Pública' },
  { id: 'DETRAN', title: 'DETRAN - Departamento de Trânsito' },
  { id: 'IFP', title: 'IFP - Instituto Félix Pacheco' },
  { id: 'IPC', title: 'IPC - Instituto de Polícia Científica' },
  { id: 'ITEP', title: 'ITEP - Instituto Técnico-Científico de Perícia' },
  { id: 'IGP', title: 'IGP - Instituto Geral de Perícias' },
  { id: 'POLITEC', title: 'POLITEC - Perícia Oficial e Identificação Técnica' },
  { id: 'DIC', title: 'DIC -  Diretoria de Identificação Civil' },
  { id: 'IIC', title: 'IIC - Instituto de Identificação Civil' },
  { id: 'IML', title: 'IML - Instituto Médico Legal' },
  { id: 'MTE', title: 'MTE - Ministério do Trabalho e Emprego' },
  { id: 'II', title: 'II - INSTITUTO DE IDENTIFICAÇÃO (CIN)' },
];

export const genderOptions = [
  { id: 'masculino', title: 'Masculino' },
  { id: 'feminino', title: 'Feminino' },
];

export const situacOptions = [
  { id: 'Próprio', title: 'Próprio' },
  { id: 'Financiado', title: 'Financiado' },
];

export const esadoCivilOptions = [
  { id: 'solteiro', title: 'Solteiro(a)' },
  { id: 'casado', title: 'Casado(a)' },
  { id: 'separado', title: 'Separado(a)' },
  { id: 'viuvo', title: 'Viúvo(a)' },
];

export const nacionalidadeOptions = [
  { id: 'brasileira', title: 'Brasileira' },
  { id: 'estrangeira', title: 'Estrangeira' },
];

export const statusOptions = [
  { id: 'pendente', title: 'Pendente' },
  { id: 'aprovado', title: 'Aprovado' },
  { id: 'recusado', title: 'Recusado' },
  { id: 'analise', title: 'Em analise' },
  { id: 'negado', title: 'Negada' },
];

export const statusBanco = [
  { id: 'em analise', title: 'Em analise' },
  { id: 'aprovado', title: 'Aprovado' },
  { id: 'recusado', title: 'Recusado' },
];

export const optionsPerfil = [
  { id: 'A', title: 'A' },
  { id: 'B', title: 'B' },
  { id: 'C', title: 'C' },
  { id: 'D', title: 'D' },
];

export const optionsCarencia = [
  { id: 30, title: 30 },
  { id: 60, title: 60 },
  { id: 90, title: 90 },
];

export const optionsPrazo = [
  { id: 6, title: 6 },
  { id: 12, title: 12 },
  { id: 24, title: 24 },
  { id: 30, title: 30 },
  { id: 36, title: 36 },
  { id: 42, title: 42 },
  { id: 48, title: 48 },
  { id: 54, title: 54 },
  { id: 60, title: 60 },
  { id: 72, title: 72 },
  { id: 84, title: 84 },
];

export const optionsSN = [
  { id: 'Sim', title: 'Sim' },
  { id: 'Não', title: 'Não' },
];

export const optionsPeriodicidade = [
  { id: 7, title: 7 },
  { id: 14, title: 14 },
  { id: 21, title: 21 },
  { id: 28, title: 28 },
  { id: 30, title: 30 },
  { id: 35, title: 35 },
  { id: 42, title: 42 },
  { id: 49, title: 49 },
  { id: 56, title: 56 },
  { id: 63, title: 63 },
];

export const optionsPrazoRenogicar = [
  { id: 3, title: 3 },
  { id: 6, title: 6 },
  { id: 9, title: 9 },
  { id: 12, title: 12 },
  { id: 18, title: 18 },
  { id: 24, title: 24 },
  { id: 30, title: 30 },
  { id: 36, title: 36 },
  { id: 48, title: 48 },
  { id: 60, title: 60 },
];

export const optionsCarteira = [
  { id: 'Propria', title: 'Propria' },
  { id: 'Bancarizada', title: 'Bancarizada' },
];

export const optionsTacTab = [
  { id: 0, title: 0 },
  { id: 1, title: 1 },
  { id: 2, title: 2 },
  { id: 3, title: 3 },
  { id: 4, title: 4 },
  { id: 5, title: 5 },
  { id: 6, title: 6 },
  { id: 7, title: 7 },
  { id: 8, title: 8 },
  { id: 9, title: 9 },
  { id: 10, title: 10 },
];
